import type { Root as MdastRoot } from "mdast";
import remarkGfm from "remark-gfm";
import remarkParse from "remark-parse";
import { unified } from "unified";
import { preprocessMarkdownForRender } from "~/utils/markdownTerms";

const markdownProcessor = unified().use(remarkParse).use(remarkGfm);

/**
 * Parses an edited markdown+HTML string back into an MDAST `root`, mirroring the
 * backend's `mdast-util-from-markdown` + gfm producer (§4) so a section saved in
 * v2 can send an updated `contentMdast` alongside `content`. Citation anchors,
 * stored as raw `<a class="source-map-link">` HTML, parse into inline `html`
 * nodes, which the v2 render pipeline materialises via `rehypeRaw` and groups by
 * class exactly as v1 does.
 *
 * The markdown is run through {@link preprocessMarkdownForRender} first — the
 * exact chain used by v1 `UnifiedMarkdown` — so wrapper fences are unwrapped,
 * mid-line block markers are broken out, and glued header/delimiter tables are
 * repaired before parsing. This keeps the persisted `contentMdast` identical to
 * what v1 renders on screen instead of freezing malformed markdown into
 * paragraph or code nodes.
 */
export function markdownToReportMdast(markdown: string): MdastRoot {
  return markdownProcessor.parse(preprocessMarkdownForRender(markdown));
}
